import React, { useState, useEffect } from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';
import { HorizontalBars } from '../../insights/HorizontalBars';

export const MostCommonTimes = ({ story, action, isPaused, config, storyData }) => {
    const [dataSortedByNumDays, setDataSortedByNumDays] = useState(null);

    useEffect(() => {
        // descending
        let objectsSortedByNumDays = storyData.data.times.sort((a, b) => {
            b.datetimes.length - a.datetimes.length
        });
        setDataSortedByNumDays(objectsSortedByNumDays);
    }, [])

    return (
        dataSortedByNumDays &&
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            <h1 className={styles.size2}>
                {storyData.data.times.length > 1 ? 'Times you were most drawn to flows' : 'Time you were most drawn to flows'}
            </h1>
            <HorizontalBars data={dataSortedByNumDays} />
        </StoryWrapper>
    )
}